//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      required: true,
      type: [ Number, String ]
    }
  },
}
